import React from "react";

const Career = () => {
  return (
    <>
      {/* ---------- Top Image Section ---------- */}
      <div className="container-fluid p-0 my-5">
  <img
    src={require("../assets/images/career.png")}
    alt="Career"
    className="img-fluid w-100"
    style={{
      maxHeight: "400px",
      objectFit: "cover"
    }}
  />
</div>

      {/* ---------- Career Section ---------- */}
      <div className="container my-5">

        {/* Heading */}
        <div className="text-center mb-5">
          <p
            className="fw-bold"
            style={{
              letterSpacing: "2px",
              color: "#153555",
              fontSize: "14px",
            }}
          >
            COME JOIN US
          </p>

          <h2
            className="fw-bold"
            style={{
              fontSize: "38px",
              color: "#153555",
            }}
          >
            Career Openings
          </h2>

          <p
            style={{
              color: "#666",
              maxWidth: "650px",
              margin: "0 auto",
              fontSize: "14px",
            }}
          >
            We’re always looking for talented people to join our team.
            Check out our current opening below.
          </p>
        </div>

        {/* Job Section */}
        <div className="row justify-content-center">

          {/* Left Category */}
          <div className="col-md-3 mb-4">
            <div>
              <p className="fw-bold" style={{ color: "#153555" }}>
                HR & ADMIN
              </p>
            </div>
          </div>

          {/* Job List */}
          <div className="col-md-7">

            {/* Job Card */}
            <div
              className="d-flex justify-content-between align-items-center p-4 mb-3"
              style={{
                backgroundColor: "#f8f9fb",
                borderRadius: "10px",
                border: "1px solid #e2e6ea",
                boxShadow: "0 3px 5px rgba(0,0,0,0.05)",
              }}
            >
              {/* Job Title */}
              <div>
                <h6
                  className="fw-bold mb-1"
                  style={{ color: "#153555" }}
                >
                  Receptionist Cum Digital Marketer
                </h6>

                <small style={{ color: "#666" }}>
                  HR & Admin Department
                </small>
              </div>

              {/* Experience */}
              <div className="text-center">
                <small style={{ color: "#888" }}>Experience</small>
                <div className="fw-bold">1 Year</div>
              </div>

              {/* Arrow */}
              <div
                style={{
                  fontSize: "20px",
                  color: "#153555",
                }}
              >
                →
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Career;